import '@getgo/chameleon-web/components/registerAll'
// start monkey patch
if (!window.process) {
  window.process = { env: {} } as NodeJS.Process
}
// end monkey patch

import Shell, { getShellLogger, GotoError } from '@goto/shell'
import { setupGtcExtensionPolyfillsAndServices } from './helpers/gtc-helpers'
import { isError } from './helpers/logging-helpers'
import { loadEnvironment } from './load-environment'
import { version } from './version'

import extensionConfigs from './extension-configs'

const NAVIGATION_ITEM_ORDER = [
  '@call', // either @call (jiveweb) or @goto/voice-main' (goto-voice) will be shown depending on a feature flag.
  '@goto/voice-main',
  'inbox',
  '@messaging',
  'oos-meeting-app',
  '@meetings',
  'engagements',

  '@goto/contacts-ui-extension',
  '@contacts',
  '@contact',

  'contact-center',
  'oos-training-app',
  'oos-webinar-app',
  'analytics',
]

// temp fix unlocking clients from errored cached route
const currentRoute = localStorage.getItem('goto-current-route')
if (currentRoute === '/errored') {
  localStorage.removeItem('goto-current-route')
}

loadEnvironment().then(async environment => {
  try {
    // This function is an exception around GTC extension
    // Due to the legacy specific to Jiveweb a helper is used to load polyfills and services for GTC
    // This should no be reproduce for other extensions
    // throw 'error'
    await setupGtcExtensionPolyfillsAndServices()

    Shell.addExtensions(extensionConfigs)
    Shell.setNavigationOrder(NAVIGATION_ITEM_ORDER)
    await Shell.start({ environment, hostAppVersion: version })
  } catch (e) {
    getShellLogger().error(
      `shell encountered an error when starting: ${e}`,
      isError(e) ? [e.name, e.message, e.stack] : undefined,
    )

    // register the custom element in case shell failed to do so
    if (!window.customElements.get(GotoError.tagName)) {
      window.customElements.define(GotoError.tagName, GotoError)
    }

    window.document.body.prepend(`
    <chameleon-theme-provider skin="gotoapp" theme="light" rebranding2021="true">
        <${GotoError.tagName} style="display: flex; height: 100%"></${GotoError.tagName}>
    </chameleon-theme-provider>
    `)
    // rethrow the error so we continue to see these errors in the console
    throw e
  }
})
